/* eslint-disable */
var $ = jQuery;

simpleMapVar = require( '../jquery.simplegmaps' ),

module.exports = function() {
	var $simpleMap = $('#simplemap');

	if( $simpleMap.length ) {
    $simpleMap.simplegmaps();
	}
};
